import React, { cloneElement } from 'react'
import { Form as FormikForm, Formik } from 'formik'

const Form = ({ children, style, ...formProps }) => {
  return (
    <Formik {...formProps}>
      {(props) => (
        <FormikForm style={style}>
          {typeof children === 'function'
            ? children(props)
            : cloneElement(children, { formikProps: props })}
        </FormikForm>
      )}
    </Formik>
  )
}

export default Form
